// extracted by mini-css-extract-plugin
module.exports = {"postPage":"_2CbEc","emptyState":"_1zPZs","recentPosts":"_3F2mA"};